import React, { useState, useRef, useEffect } from "react";
import axios from "axios";
import "../Pincodefinder/Pincode.css";
import Logo from "../Logo/shreeshyalogo.jpg";


/* ================= HEADER ADD KIYA ================= */

const Header: React.FC = () => {
  useEffect(() => {
  document.title = "Shree Shyam Express";
}, []);


  const [menuOpen, setMenuOpen] = useState(false);
  const [loginOpen, setLoginOpen] = useState(false);

  const menuRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    function handleClickOutside(event: MouseEvent) {
      if (
        menuRef.current &&
        !menuRef.current.contains(event.target as Node)
      ) {
        setMenuOpen(false);
        setLoginOpen(false);
      }
    }

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (

    <header className="premium-header">

      <div className="marquee-container">
        <div className="marquee-text">
          Welcome To Shree Shyam Express Courier and Cargo  |  Fast, Reliable, and Affordable Delivery Services Across India! |  Track Your Shipments in Real-Time with Our Advanced Tracking System! |  Join Our Growing Network of Satisfied Customers Today! | Use Dropdown For Selecting Pincode Locator !
        </div>
      </div>

      <div className="header-container">

        <div className="brand-logo">

          <img src={Logo} alt="Logo" className="logo-img" />
        </div>

        <div className="hamburger" onClick={() => setMenuOpen(!menuOpen)}>
          <span></span>
          <span></span>
          <span></span>
        </div>

        {/* ✅ IMPORTANT: ref lagaya */}
        <nav
          ref={menuRef}
          className={`nav-menu ${menuOpen ? "show" : ""}`}
        >
          <a href="https://shreeshyamexp.com/index.php">Home</a>
          <a href="https://shreeshyamexp.com/about.php">Company</a>
          <a href="https://shreeshyamexp.com/service.php">Services</a>
          <a href="https://shreeshyamexp.com/Pincode/">Pincode</a>

          <div className="nav-dropdown">
            <button
              className="nav-dropbtn"
              onClick={() => setLoginOpen(!loginOpen)}
            >
              Login ▾
            </button>

            <div className={`nav-dropdown-content ${loginOpen ? "open" : ""}`}>
              <a href="https://softctl.shreeshyamexp.com/#/auth/login">
                Branch Login
              </a>
              <a href="/">Customer Login</a>
            </div>
          </div>

          <a
            href="https://shreeshyamexp.com/ShreeshyamTracking/"
            className="tracking-btn"
          >
            Tracking
          </a>

          <a href="https://shreeshyamexp.com/contact.php">Contact</a>
        </nav>

      </div>
    </header>
  );
};



/* ================= AAPKA ORIGINAL CODE ================= */

const Pincode: React.FC = () => {
  const [searchValue, setSearchValue] = useState("");
  const [error, setError] = useState("");
  const [pincodeData, setPincodeData] = useState<any[]>([]);
  const [loading, setLoading] = useState(false);
  const [darkMode, setDarkMode] = useState(false);

  const resultRef = useRef<HTMLDivElement | null>(null);

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value.replace(/\D/g, "").slice(0, 6);
    setSearchValue(value);
    setError("");
    setPincodeData([]);
  };

  const fetchData = async () => {
    if (searchValue.length !== 6) {
      setError("Enter valid 6-digit PIN code");
      return;
    }

    setLoading(true);
    setError("");
    setPincodeData([]);

    try {
      const res = await axios.get(
        `https://shreeshyamexp.com/ShreeshyamTrackingApi/pincodefinder?Pincode=${searchValue}`
      );

      let result: any[] = [];

      if (Array.isArray(res.data)) result = res.data;
      else if (Array.isArray(res.data.data)) result = res.data.data;

      if (result.length > 0) {
        setPincodeData(result);
      } else {
        setError("Not Serviceable");
      }
    } catch {
      setError("Not Serviceable");
    }

    setLoading(false);
  };

  return (
    <>
      {/* HEADER ADD KIYA */}
      <Header />

 
      {/* ================= HERO SECTION ================= */}
      <section className={`pincode-hero ${darkMode ? "dark" : ""}`}>

        {/* Dark Mode Toggle */}
        <div className="dark-toggle">
          <button onClick={() => setDarkMode(!darkMode)}>
            {darkMode ? "☀ Light Mode" : "🌙 Dark Mode"}
          </button>
        </div>

        {/* HERO TEXT */}
        <div className="hero-container">
          <div className="hero-badge">📍 Pincode Checker</div>

          <h1 className="hero-title">
            Check <span>Delivery Availability</span>
          </h1>

          <p className="hero-subtitle">
            Enter your pincode to instantly check if we deliver to your area.
            We serve 500+ destinations across India.
          </p>
        </div>

        {/* ================= SEARCH CARD ================= */}
        <div className="search-card">


<div className="pincode-header">
<div className="pincode-icon">
  <svg
    width="28"
    height="28"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12 2L3 7L12 12L21 7L12 2Z"
      stroke="white"
      strokeWidth="2"
      strokeLinejoin="round"
    />
    <path
      d="M3 7V17L12 22L21 17V7"
      stroke="white"
      strokeWidth="2"
      strokeLinejoin="round"
    />
    <path
      d="M12 12V22"
      stroke="white"
      strokeWidth="2"
      strokeLinejoin="round"
    />
  </svg>
</div>


  <h2>Check Your Pincode</h2>

  <p>Get instant delivery availability for your location</p>

</div>


          <div className="search-row">

            {/* INPUT WITH SVG ICON */}
            <div className="input-wrapper">

              <span className="input-icon">
                <svg
                  width="18"
                  height="18"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <circle cx="11" cy="11" r="8" />
                  <line x1="21" y1="21" x2="16.65" y2="16.65" />
                </svg>
              </span>

              <input
                type="text"
                placeholder="Enter 6-digit pincode"
                value={searchValue}
                onChange={handleInputChange}
                onKeyDown={(e) => {
                  if (e.key === "Enter" && searchValue.length === 6) {
                    fetchData();
                  }
                }}
                className="search-input"
              />
            </div>

            {/* BUTTON */}
            <button
              onClick={fetchData}
              disabled={searchValue.length !== 6 || loading}
              className={`check-btn ${searchValue.length === 6 ? "active" : ""}`}
            >
              {loading ? "Checking..." : "Check Now"}
            </button>

          </div>




          {/* LOADING */}
          {loading && <div className="spinner"></div>}

          {/* ================= RESULT AREA ================= */}
          <div ref={resultRef}>

            {/* SUCCESS */}
            {pincodeData.length > 0 && (
              <div className="success-card">

                <div className="success-header">
                  <div className="success-icon">✓</div>
                  <div className="success-title">Delivery Available</div>
                </div>

                <div className="table-wrapper">
                  <table className="result-table">
                    <thead>
                      <tr>
                        <th>Sr</th>
                        <th>Area</th>
                        <th>Destination</th>
                        <th>State</th>
                        {/* <th>Pincode</th> */}
                        <th>Service</th>
                        
                      </tr>
                    </thead>
                    <tbody>
                      {pincodeData.map((item, index) => (
                        <tr key={index}>
                          <td>{index + 1}</td>
                          <td>{item.Area_Name}</td>
                          <td>{item.Destination_Name}</td>
                          {/* <td>{item.Pincode}</td> */}
                          <td>{item.State_Name}</td>
                          <td>
                            <span className="service-badge">
                              {item.ODA_OPA}
                            </span>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>

              </div>
            )}

            {/* ERROR */}
        {/* ERROR */}
{error && (
  <div className="error-card">

    <div className="error-icon">
      <div className="icon-circle">
        ✕
      </div>
    </div>

    <div className="error-content">
      <h3>Not Serviceable Yet</h3>

      <p>
        Sorry, we don't currently deliver to pincode{" "}
        <strong>{searchValue}</strong>. We're expanding daily!
      </p>

      <div className="error-buttons">
        <a
          href="https://shreeshyamexp.com/contact.php"
          className="btn-primary"
        >
          Contact Us
        </a>

        <button
          className="btn-secondary"
          onClick={() => {
            setSearchValue("");
            setError("");
          }}
        >
          Try Another
        </button>
      </div>
    </div>

  </div>
)}


          </div>
        </div>
<div className="pincode-features">
  <div className="feature-item">
    <span className="dot green"></span>
    500+ Destinations
  </div>

  <div className="feature-item">
    <span className="dot blue"></span>
    Pan India Coverage
  </div>

  <div className="feature-item">
    <span className="dot teal"></span>
    Same Day Delivery
  </div>
</div>

      </section>

      {/* ================= FOOTER ================= */}
       <footer className="footer">
                {/* Top Section */}
                <div className="footer-top">
                    <h2>Join Us Today And let Us Help You To Grow Your Business.</h2>
                    <button className="footer-btn">Get Started →</button>
                </div>

                {/* Bottom Section */}
                <div className="footer-content">
                    {/* Logo + About */}
                    <div className="footer-col">
                        <div

                        >
                            <img
                                src={Logo}
                                alt="Company Logo"
                                className="img-fluid"
                                style={{ height: '100px', width: 'auto', marginTop: '-40px' }}
                            />
                        </div>
                        <p>
                            Reliable delivery services offering fast shipping, real-time
                            tracking, and secure handling of your packages for local and
                            international destinations
                        </p>
                        <div className="social-icons">
                            <a href="#"><i className="fab fa-instagram"></i></a>
                            <a href="#"><i className="fab fa-facebook"></i></a>
                        </div>
                    </div>

                    {/* Quick Links */}
                    <div className="footer-col">
                        <h4>Quick Links</h4>
                        <ul>
                            <li><a href="/">Home</a></li>
                            <li><a href="/service">Service</a></li>
                            <li><a href="/about">About Us</a></li>
                            <li><a href="/tracking">Tracking</a></li>
                            <li><a href="/contact">Contact Us</a></li>
                        </ul>
                    </div>

                    {/* Services */}
                    <div className="footer-col">
                        <h4>Services</h4>
                        <ul>
                            <li>Surface Cargo</li>
                            <li>Air Cargo</li>
                            <li>Bulk Express</li>
                            <li>Door To Door Delivery</li>
                            <li>Next Day Delivery</li>
                        </ul>
                    </div>

                    {/* Address */}
                    <div className="footer-col">
                        <h4>Address</h4>
                        <p>
                            <strong>Head Office</strong><br />
                            Rahul Complex, 2nd Wings, Block No.12,<br />
                            Near S.T. Bus Stand, Ganesh Path<br />
                            Nagpur - 440018
                        </p>
                        <p><strong>Phone:</strong> +91 9226086824 / 9226086827 / 9226086823</p>
                        <p><strong>Mail:</strong> customers@shreeshyamexp.com</p>
                    </div>
                </div>

                {/* Bottom Bar */}
                <div className="footer-bottom">
                    <p style={{ color: "white" }}>Copyright ©2024 Shree Shyam Express Courier & Cargo. All Rights Reserved</p>
                    <div>
                        <a href="/terms">Terms & Conditions</a> | <a href="/privacy">Privacy Policy</a>
                    </div>
                </div>
            </footer>
    </>
  );
};

export default Pincode;



